/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropparticipationweb2Inputs */

const en_dropparticipationweb2 = /** @type {(inputs: Dropparticipationweb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App and website`)
};

const de_dropparticipationweb2 = /** @type {(inputs: Dropparticipationweb2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auch im Web`)
};

/**
* | output |
* | --- |
* | "App and website" |
*
* @param {Dropparticipationweb2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropparticipationweb2 = /** @type {((inputs?: Dropparticipationweb2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropparticipationweb2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropparticipationweb2(inputs)
	return de_dropparticipationweb2(inputs)
});
export { dropparticipationweb2 as "dropParticipationWeb" }